import { FC } from "react";
import { useDispatch } from "react-redux";

import { UserVehicleForm } from "Bands/components";
import { createUserVehicle, dispatchGetUserVehicles } from "Bands/state";
import { IUserVehiclePatchData, USER_ACTIONS } from "Bands/types";
import { copy } from "shared/assets";
import { IFormButtons } from "shared/types";
import { UserEntityModal } from "Bands/containers";
import { Car } from "shared/assets/icons";

const { userVehicle: vehicleCopy } = copy;

interface Props {
  handleClose: () => void;
}

export const CreateUserVehicleModal: FC<Props> = ({ handleClose }) => {
  const dispatch = useDispatch();

  const buttons: IFormButtons = {
    primary: {
      children: vehicleCopy.buttons.create,
    },
    secondary: {
      onClick: handleClose,
    },
  };

  const handleSubmit = (data: IUserVehiclePatchData) => {
    dispatch(createUserVehicle(data));
  };

  const handleSuccess = () => {
    dispatchGetUserVehicles(dispatch);
  };

  return (
    <UserEntityModal
      title={vehicleCopy.create.title}
      icon={Car}
      action={USER_ACTIONS.createUserVehicle}
      buttons={buttons}
      successMessage={vehicleCopy.messages.created}
      Component={UserVehicleForm}
      handleSubmit={handleSubmit}
      handleClose={handleClose}
      handleSuccess={handleSuccess}
    />
  );
};
